
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"61","height":"61"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Groupe 1454","transform":"translate(-16611.5 4029.442)"}},[_c('rect',{attrs:{"data-name":"Rectangle 1269","width":"61","height":"61","rx":"5","transform":"translate(16611.5 -4029.442)","fill":"#f9fafb"}}),_c('g',{attrs:{"data-name":"Groupe 1286"}},[_c('path',{attrs:{"data-name":"Tracé 6745","d":"M16651.482-4015.332l-5.92 5.039h-12.729v.014a1.7 1.7 0 00-1.746 1.707v1.775h-4.366a1.748 1.748 0 00-1.746 1.718v15.769a1.76 1.76 0 001.746 1.734h4.366v4.369a.887.887 0 00.5.778.9.9 0 00.928-.123l5.907-5.024h12.747a1.751 1.751 0 001.746-1.734v-1.761h4.366a1.76 1.76 0 001.746-1.734v-15.769a1.748 1.748 0 00-1.746-1.72h-4.366v-4.369a.908.908 0 00-.516-.789.9.9 0 00-.916.12zm-.314 2.539v3.372a.908.908 0 00.873.874h5.239v15.728h-24.447v-15.727h13.042a.876.876 0 00.573-.218zm-6.112 5.557a4.373 4.373 0 00-3.779 2.13.873.873 0 101.446.969 2.27 2.27 0 012.333-1.352 2.318 2.318 0 012.183 2.184 1.8 1.8 0 01-.75 1.42 17.571 17.571 0 01-1.924 1.338.89.89 0 00-.382.737v2.184a.873.873 0 101.746 0v-1.734a11.917 11.917 0 001.733-1.229 3.69 3.69 0 001.323-2.717 4.153 4.153 0 00-3.928-3.93zm-18.336 2.184h4.366v12.247a1.76 1.76 0 001.746 1.734h18.337v1.747h-13.043a.873.873 0 00-.573.2l-4.72 4.027v-3.359a.908.908 0 00-.873-.874h-5.239zm18.336 9.175a.874.874 0 10.873.874.873.873 0 00-.872-.873z","fill":"#044370"}})])])])
          )
        }
      }
    